module.exports = __webpack_public_path__ + "img/1.921fae5c.png";